var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSrGold4X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_1838)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 3C7.50236 3 7.08044 3.36593 7.01006 3.85858L6.01006 10.8586C5.96906 11.1456 6.05462 11.4362 6.24455 11.6552C6.43449 11.8742 6.71012 12 7.00001 12H2.11112C1.61935 12 1.20058 12.3575 1.12348 12.8432L0.0123717 19.8432C-0.0334986 20.1322 0.0494999 20.4268 0.239492 20.6493C0.429484 20.8718 0.707406 21 1.00001 21H11C11.2926 21 11.5705 20.8718 11.7605 20.6493C11.9155 20.4678 11.9993 20.2384 12 20.0031C12.0007 20.2384 12.0845 20.4678 12.2395 20.6493C12.4295 20.8718 12.7074 21 13 21H23C23.2926 21 23.5705 20.8718 23.7605 20.6493C23.9505 20.4268 24.0335 20.1322 23.9876 19.8432L22.8765 12.8432C22.7994 12.3575 22.3807 12 21.8889 12H17C17.2899 12 17.5655 11.8742 17.7555 11.6552C17.9454 11.4362 18.031 11.1456 17.99 10.8586L16.99 3.85858C16.9196 3.36593 16.4977 3 16 3H8.00001ZM14.1111 12H9.8889C10.3807 12 10.7994 12.3575 10.8765 12.8432L11.9876 19.8432C11.9958 19.8944 11.9998 19.9458 12 19.9969C12.0002 19.9458 12.0042 19.8944 12.0124 19.8432L13.1235 12.8432C13.2006 12.3575 13.6194 12 14.1111 12ZM8.15302 10L8.8673 5H15.1327L15.847 10H8.15302ZM2.96491 14L2.17126 19H9.82876L9.03511 14H2.96491ZM14.9649 14L14.1713 19H21.8288L21.0351 14H14.9649Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_1838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrGold4X);
export default __webpack_public_path__ + "static/media/sr_gold_4x.a068a8c54cfd9152895e56609feb2b30.svg";
export { ForwardRef as ReactComponent };